<template>
  <div class="main" @click="activeItem(0)">
    <div class="journey-effect cant-select" @click="active = 0">
      <img src="img/website/journey.svg" alt="Jornada do Franqueado" loading = “lazy”/>
    </div>
    <div class="title-area" @click="active = 0">
      <div class="title-effect">
        <img src="img/website/dots.svg" alt="Efeitos de bolinha" loading = “lazy”/>
      </div>
      <h5 class="title" @click="active = 0">
        <span>jornada</span><br />
        do franqueado
      </h5>
    </div>
    <div class="lead" @click="active = 0">
      Nós somos a OdontoTop - Hospital do Dente, a franquia especializada em
      resgatar sorrisos. Vamos fazer história juntos?
    </div>

    <!-- Slider -->
    <div class="journey-slider" @mouseover="active = 0">
      <div class="journey-slider__item cadastro" @click="activeItem(1)">
        <div
          class="journey-slider__item--path path-top path-reverse-reverse"
        ></div>
        <div class="journey-slider__item--path main-path"></div>
        <div class="journey-slider__item--number">1</div>
        <div class="journey-slider__item--icon">
          <img src="img/website/journey.webp?v=2" alt="Cadastro" loading = “lazy”/>
        </div>
        <div class="journey-slider__item--name">Cadastro</div>
        <div
          class="journey-slider__item--popup"
          :class="active == 1 ? 'journey-slider__item--popup--active' : ''"
        >
          <div class="journey-slider__item--popup-text">
            Antes de entrar para a família OdontoTop, o primeiro passo é se
            cadastrar para o nosso time entrar em contato com você.
          </div>
          <div class="journey-slider__item--popup-cta">
            <button
              data-toggle="modal"
              data-target="#franchModal"
              class="cta-modal"
            >
              Cadastrar
            </button>
          </div>
        </div>
      </div>
      <div class="journey-slider__item analise" @click="activeItem(2)">
        <div
          class="journey-slider__item--path path-bottom path-reverse-reverse"
        ></div>
        <div class="journey-slider__item--number">2</div>
        <div class="journey-slider__item--icon">
          <img src="img/website/journey1.webp?v=2" alt="Análise de perfil" loading = “lazy”/>
        </div>
        <div class="journey-slider__item--name">Análise de perfil</div>
        <div
          class="journey-slider__item--popup"
          :class="active == 2 ? 'journey-slider__item--popup--active' : ''"
        >
          <div class="journey-slider__item--popup-text">
            Entramos em contato com o futuro franqueado, procurando conhecer e
            identificar se o seu perfil está alinhado com o propósito do
            Hospital do Dente.
          </div>
          <div class="journey-slider__item--popup-cta">
            <button
              data-toggle="modal"
              data-target="#franchModal"
              class="cta-modal"
            >
              Cadastrar
            </button>
          </div>
        </div>
      </div>
      <div class="journey-slider__item negociacao" @click="activeItem(3)">
        <div
          class="journey-slider__item--path path-top path-reverse-reverse"
        ></div>
        <div class="journey-slider__item--number">3</div>
        <div class="journey-slider__item--icon">
          <img src="img/website/journey2.webp?v=2" alt="Negociação" loading = “lazy”/>
        </div>
        <div class="journey-slider__item--name">Negociação</div>
        <div
          class="journey-slider__item--popup"
          :class="active == 3 ? 'journey-slider__item--popup--active' : ''"
        >
          <div class="journey-slider__item--popup-text" @click="activeItem(0)">
            Após a identificação do perfil, o futuro franqueado visita a
            Franchising, conhece a estrutura e faz uma reunião presencial para
            tirar todas as dúvidas e formalizar sua entrada à família OdontoTop.
          </div>
          <div class="journey-slider__item--popup-cta">
            <button
              data-toggle="modal"
              data-target="#franchModal"
              class="cta-modal"
            >
              Cadastrar
            </button>
          </div>
        </div>
      </div>
      <div class="journey-slider__item onboarding" @click="activeItem(4)">
        <div
          class="journey-slider__item--path path-bottom path-reverse-reverse"
        ></div>
        <div class="journey-slider__item--number">4</div>
        <div class="journey-slider__item--icon">
          <img src="img/website/journey3.webp?v=2" alt="Onboarding" loading = “lazy”/>
        </div>
        <div class="journey-slider__item--name">Onboarding</div>
        <div
          class="journey-slider__item--popup"
          :class="active == 4 ? 'journey-slider__item--popup--active' : ''"
        >
          <div class="journey-slider__item--popup-text">
            Nessa etapa, o franqueado já faz parte do nosso grupo e começa a
            respirar a OdontoTop, recebendo acessos e participando de
            treinamentos.
          </div>
          <div class="journey-slider__item--popup-cta">
            <button
              data-toggle="modal"
              data-target="#franchModal"
              class="cta-modal"
            >
              Cadastrar
            </button>
          </div>
        </div>
      </div>
      <div class="journey-slider__item planejamento" @click="activeItem(5)">
        <div class="journey-slider__item--path path-top path-reverse"></div>
        <div class="journey-slider__item--number">5</div>
        <div class="journey-slider__item--icon">
          <img src="img/website/journey4.webp?v=2" alt="Planejamento" loading = “lazy”/>
        </div>
        <div class="journey-slider__item--name">Planejamento</div>
        <div
          class="journey-slider__item--popup"
          :class="active == 5 ? 'journey-slider__item--popup--active' : ''"
        >
          <div class="journey-slider__item--popup-text">
            Ajudamos o franqueado em todos seus passos para ele ter uma franquia
            de sucesso. Não há início, meio e fim, pois seguramos a mão do
            franqueado e continuamos o ajudando interminavelmente.
          </div>
          <div class="journey-slider__item--popup-cta">
            <button
              data-toggle="modal"
              data-target="#franchModal"
              class="cta-modal"
            >
              Cadastrar
            </button>
          </div>
        </div>
      </div>
      <div class="journey-slider__item projeto" @click="activeItem(6)">
        <div class="journey-slider__item--path path-bottom path-reverse"></div>
        <div class="journey-slider__item--number">6</div>
        <div class="journey-slider__item--icon">
          <img src="img/website/journey5.webp?v=2" alt="Cadastro" loading = “lazy”/>
        </div>
        <div class="journey-slider__item--name">Projeto e execução</div>
        <div
          class="journey-slider__item--popup"
          :class="active == 6 ? 'journey-slider__item--popup--active' : ''"
        >
          <div class="journey-slider__item--popup-text">
            Possuímos um processo rápido e eficiente de implantação. Auxiliamos
            em toda burocracia da obra e liberação para funcionamento do
            Hospital do Dente.
          </div>
          <div class="journey-slider__item--popup-cta">
            <button
              data-toggle="modal"
              data-target="#franchModal"
              class="cta-modal"
            >
              Cadastrar
            </button>
          </div>
        </div>
      </div>
      <div class="journey-slider__item treinamento" @click="activeItem(7)">
        <div class="journey-slider__item--path path-top path-reverse"></div>
        <div class="journey-slider__item--number">7</div>
        <div class="journey-slider__item--icon">
          <img src="img/website/journey6.webp?v=2" alt="Cadastro" loading = “lazy”/>
        </div>
        <div class="journey-slider__item--name">Treinamento</div>
        <div
          class="journey-slider__item--popup"
          :class="active == 7 ? 'journey-slider__item--popup--active' : ''"
        >
          <div class="journey-slider__item--popup-text">
            Período dedicado ao desenvolvimento dos novos colaboradores para a
            inauguração. Mas não se engane, aqui o treino é constante, nunca
            termina.
          </div>
          <div class="journey-slider__item--popup-cta">
            <button
              data-toggle="modal"
              data-target="#franchModal"
              class="cta-modal"
            >
              Cadastrar
            </button>
          </div>
        </div>
      </div>
      <div class="journey-slider__item inauguracao" @click="activeItem(8)">
        <div class="journey-slider__item--path path-reverse"></div>
        <div class="journey-slider__item--number">8</div>
        <div class="journey-slider__item--icon">
          <img src="img/website/journey7.webp?v=2" alt="Inauguração" loading = “lazy”/>
        </div>
        <div class="journey-slider__item--name">Inauguração</div>
        <div
          class="journey-slider__item--popup"
          :class="active == 8 ? 'journey-slider__item--popup--active' : ''"
        >
          <div class="journey-slider__item--popup-text">
            Celebramos ao lado do franqueado o momento mais aguardado de sua
            jornada e reforçamos o compromisso de acompanhá-lo em toda sua etapa
            futura.
          </div>
          <div class="journey-slider__item--popup-cta">
            <button
              data-toggle="modal"
              data-target="#franchModal"
              class="cta-modal"
            >
              Cadastrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0
    }
  },
  methods: {
    activeItem(item) {
      if (this.active !== 0) {
        return this.active = 0
      }
      this.active = item
      console.log('ativo')
    }
  },
};
</script>
<style lang="scss" scoped>
.main {
  font-family: "Roboto", sans-serif;
  width: 100%;
  margin: 30px;
  min-height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  align-items: center;
  @media (max-width: 1200px) {
    overflow: hidden;
  }
  @media screen and (max-width: 768px) {
    margin: 0;
  }
  .journey-effect {
    position: absolute;
    right: -35px;
    top: 2rem;
    width: 250px;
  }
  .lead {
    align-self: flex-start;
    color: var(--gray);
    font-size: 18px;
    margin-left: 151px;
    margin-top: 1.5rem;
    width: 50%;
  }

  // Slider
  .journey-slider {
    display: flex;
    height: 500px;
    margin-top: 48px;
    &__item {
      height: fit-content;
      position: relative;
      width: 150px;
      &:hover {
        .journey-slider__item--popup {
          opacity: 1;
          pointer-events: all;
          visibility: visible;
        }
      }

      &:nth-child(2n) {
        align-self: flex-end;
      }
      @media screen and (min-width: 1200px) {
        &:last-child .journey-slider__item--path.path-reverse {
          display: none;
        }
      }
      &--path {
        background-color: white;
        background-image: linear-gradient(
          to right,
          var(--yellow) 33%,
          rgba(255, 255, 255, 0) 0%
        );
        background-position: bottom;
        background-size: 12px 4px;
        background-repeat: repeat-x;
        left: 50%;
        position: absolute;
        transform-origin: top left;
        height: 4px;
        width: 300px;
        z-index: -1;
        &.path-bottom {
          bottom: 95px;
          transform: rotate(-66deg);
        }
        &.path-top {
          transform: rotate(66deg);
          top: 75px;
        }
        &:first-child & .path-reverse,
        &.main-path {
          display: none;
        }
      }
      &--number {
        align-items: center;
        background: var(--blue);
        border-radius: 50%;
        color: #fff;
        display: flex;
        font-size: 24px;
        font-weight: 900;
        height: 45px;
        justify-content: center;
        left: 0;
        position: absolute;
        top: 0;
        width: 45px;
      }
      &--icon {
        align-items: center;
        background: #fff;
        border: 10px solid var(--yellow);
        border-radius: 50%;
        display: flex;
        height: 150px;
        justify-content: center;
        width: 150px;
        img {
          width: 55%;
        }
      }
      &--name {
        color: var(--blue);
        font-size: 18px;
        font-weight: 700;
        margin-top: 0.75rem;
        overflow: visible;
        text-align: center;
        width: 100%;
        white-space: nowrap;
      }
      &--popup {
        background: var(--blue);
        border-radius: 16px;
        left: 60%;
        opacity: 0;
        padding: 16px;
        pointer-events: none;
        position: absolute;
        bottom: 60%;
        transform-origin: bottom left;
        transition: all 0.3s;
        visibility: none;
        width: 270px;
        z-index: 1;
        &-text {
          color: #fff;
          font-size: 16px;
        }
        &-cta {
          width: 100%;
          button {
            background: #14aa00;
            border: 0;
            border-radius: 8px;
            color: #fff;
            display: block;
            margin: 8px auto 0;
            outline: none;
            padding: 4px 0;
            text-align: center;
            transition: all 0.3s;
            width: 50%;
            &:hover {
              background: #018f20;
            }
            @media (max-width: 767px) {
              width: 100%;
            }
          }
        }
        &::before {
          border-style: solid;
          border-width: 20px 45px 20px 0;
          border-color: transparent var(--blue) transparent transparent;
          bottom: -20px;
          content: "";
          height: 0;
          left: -20px;
          position: absolute;
          transform: rotate(-45deg);
          width: 0;
        }
        @media (max-width: 767px) {
          bottom: 0;
          left: 0 !important;
          padding: 10px;
          width: 100%;
          &:before,
          &:after {
            display: none;
          }
        }
      }
    }
  }
  @media (max-width: 1920px) {
    .journey-slider__item {
      &:last-child {
        .journey-slider__item--popup {
          left: unset;
          right: 60%;
          &::before {
            bottom: -15px;
            left: unset;
            right: -20px;
            transform: scaleX(-1) rotate(-45deg);
          }
        }
      }
    }
  }
  @media (max-width: 1440px) {
    .journey-slider__item {
      width: 120px;
      &:nth-child(7) {
        .journey-slider__item--popup {
          left: unset;
          right: 60%;
          &::before {
            bottom: -15px;
            left: unset;
            right: -20px;
            transform: scaleX(-1) rotate(-45deg);
          }
        }
      }
    }
  }
  @media screen and (max-width: 1200px) {
    .journey-slider {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      gap: 0px 0px;
      grid-template-areas:
        "cadastro analise negociacao onboarding"
        "planejamento projeto treinamento inauguracao";
      width: 100%;
      &__item {
        margin: 0 auto;
        height: 120px;
        width: 120px;
        &--icon {
          height: 120px;
          width: 120px;
        }
        &:nth-child(2n) {
          align-self: unset;
        }
        &--path {
          &.path-bottom,
          &.path-top {
            display: none;
          }
          &.path-reverse {
            display: block;
            top: 60px;
            transform: scaleX(-1);
          }
          &.path-reverse-reverse {
            display: block;
            top: 60px;
            transform: scaleX(1);
          }
        }
      }
    }
  }
  @media (max-width: 1024px) {
    margin-bottom: 2rem;
    min-height: max-content;
    .journey-effect {
      display: none;
    }
    .journey-slider {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      gap: 0px 0px;
      grid-template-areas:
        "cadastro analise negociacao onboarding"
        "planejamento projeto treinamento inauguracao";
      width: 100%;
      &.cadastro {
        grid-area: cadastro;
      }
      &.analise {
        grid-area: analise;
      }
      &.negociacao {
        grid-area: negociacao;
      }
      &.onboarding {
        grid-area: onboarding;
      }
      &.planejamento {
        grid-area: planejamento;
      }
      &.projeto {
        grid-area: projeto;
      }
      &.treinamento {
        grid-area: treinamento;
      }
      &.inauguracao {
        grid-area: inauguracao;
      }
      &__item {
        margin: 0 auto;
        width: 120px;
        &:nth-child(2n) {
          align-self: unset;
        }
        &--path {
          width: 100vw;
          &.main-path {
            top: 60px;
          }
          &.path-reverse {
            display: block;
            top: 60px;
            transform: scaleX(-1);
          }
          &.path-reverse-reverse {
            display: block;
            top: 60px;
            transform: scaleX(1);
          }
        }
        &--icon {
          margin: auto;
          width: 120px;
          height: 120px;
        }
      }
    }
  }
  @media screen and (max-width: 600px) {
    .journey-slider {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr 1fr 1fr;
      grid-template-areas:
        "cadastro analise"
        "negociacao onboarding"
        "planejamento projeto"
        "treinamento inauguracao";
      height: 600px;
      &__item {
        height: 150px;
        margin-bottom: 1rem;
        width: 150px;
        & .path-reverse,
        & .path-reverse-reverse {
          display: none;
        }
      }
    }
  }
  @media (max-width: 480px) {
    margin: 0px;
    margin-bottom: 5px;
    .journey-effect {
      display: none;
    }
    .lead {
      margin-left: 70px;
      width: 75%;
    }
    .journey-slider {
      height: inherit;
      &__item {
        margin-bottom: 1rem;
        &--path,
        &--path.path-reverse {
          display: none;
        }
      }
    }
  }
}
.journey-slider__item--popup--active {
  opacity: 1 !important;
  visibility: visible !important;
}
</style>
